<template>
  <div class="bn-wrap">
    <div class="bn-l">
      <div class="img-wrap"><img :src="thumbnailUrl" alt="강의 배너"></div>
    </div>
    <div class="bn-r">
      <div class="apply-wrap" v-bind:class="{fixed: useApplyButton && scrollPosition > 200}">
        <ul class="tag-tp1">
          <li v-for="tag in product.sellTags" :key="tag">
            {{ tag }}
          </li>
        </ul>
        <p class="tit">{{ product.title }}</p>
        <ul class="info">
          <li>{{ product.servicePeriod }}</li>
          <template v-if="isDiscounted">
            <li><span style="text-decoration:line-through; color:#FBBC05">{{ product.price }} ETH</span> {{ product.resultPrice }}ETH</li>
          </template>
          <template v-else>
            <li>{{ product.resultPrice }}ETH</li>
          </template>
        </ul>
        <ul class="tx-list">
          <li v-for="shortDescription in product.shortDescriptions" :key="shortDescription">
            {{ shortDescription }}
          </li>
        </ul>
        <a v-if="useApplyButton" :href="applyLink" class="btn-primary" style="margin-top:30px">신청하기</a>
        <a v-if="useApplyButton" :href="reviewLink" class="btn-secondary" style="margin-top:10px">리뷰작성</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductBanner",
  props: ["product", "useApplyButton"],
  data() {
    return {
      scrollPosition: null,
    }
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  computed: {
    applyLink() {
      return '/billing?productCode=' + this.product.code
    },
    reviewLink() {
      return '/review?productCode=' + this.product.code
    },
    thumbnailUrl() {
      return require('../../assets' + this.product.thumbnailUrl)
    },
    isDiscounted() {
      return this.product.discountPrice !== 0
    }
  }
}
</script>

<style scoped>
.btn-primary {
  display: block;
  width: 100%;
  height: 46px;
  font-size: 16px;
  line-height: 46px;
  text-align: center;
  color: #000;
  border-radius: 6px;
  background: #53d2e3;
}

.btn-secondary {
  display: block;
  width: 100%;
  height: 46px;
  font-size: 16px;
  line-height: 46px;
  text-align: center;
  color: #000;
  border-radius: 6px;
  background: #E5E5E5;
}
</style>
